import React, { useContext } from "react";
import { useSelector } from "react-redux";
import { MixtureTabItemsStyled, MixtureTabStyled } from "./MixtureTabStyled";
import { getValueForKey } from "../../context/translationsUtils";
import { TranslationContext } from "../../context/TranslationContext";
import { TranslationContextInterface } from "../../entities/Language";
import { CondimentInterface } from "../../entities/Condiment";
import MixtureTabItem from "./MixtureTabItem/MixtureTabItem";
import Flex from "../../UI/Flex";
import { JUSTIFY_CONTENT } from "../../entities/Flex";
import Button from "../../UI/Button";
import { ButtonStyledWidth } from "../../entities/Button";
import { getSelectedCondiments } from "../Condiment/selectors";
import Typography from "../../UI/Typography/Typography";
import { TYPOGRAPHY_TYPE } from "../../entities/Typography";
import { useAppDispatch } from "../../store/store";
import { clearSelectedCondiments } from "../Condiment/CondimentSlice";
import { useNavigate } from "react-router-dom";
import { WebConfiguratorPath } from "../../routes/routes";
import { setInitialSetUp } from "../Mixture/MixtureSlice";
import { TEST_ID } from "../../shared/testid";
import { getTenantCredentials } from "../Tenant/selectors";

const MixtureTab: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { translations }: TranslationContextInterface =
  useContext(TranslationContext);
  const selectedCondiments = useSelector(getSelectedCondiments);
  const credentials = useSelector(getTenantCredentials);

  const onConfigMix = () => {
    navigate(WebConfiguratorPath.CREATE_MIX);
    dispatch(setInitialSetUp(selectedCondiments));
  };

  return (
    <MixtureTabStyled
      className="mixture-tab"
      $border={credentials?.webshopDesigns?.at(0)?.colorBorderBlock}
      data-length={selectedCondiments.length}
    >
      <div className="mixture-table__title">
        <Typography type={TYPOGRAPHY_TYPE.TITLE_FOUR}>
          {getValueForKey(translations, "nav_bar.nav_card_mix_ingredients")}
        </Typography>
      </div>
      <MixtureTabItemsStyled data-testid={TEST_ID.MIXTURE_TAB.SELECTED_ITEMS}>
        {selectedCondiments.map((condiment: CondimentInterface) => (
          <MixtureTabItem
            key={condiment.id}
            name={condiment.name}
            image={condiment.image}
          />
        ))}
      </MixtureTabItemsStyled>
      {selectedCondiments.length ? (
        <Flex
          styles={{
            justify: JUSTIFY_CONTENT.SPACE_BETWEEN,
          }}
          className="buttons-flex"
        >
          <Button
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_mix_delete_button",
            )}
            styles={{
              width: ButtonStyledWidth.FULL,
              $margin: "0 20px 0 0",
            }}
            testid={TEST_ID.MIXTURE_TAB.DELETE_BUTTON}
            onClick={() => dispatch(clearSelectedCondiments())}
            className="transparent"
          />
          <Button
            styles={{
              width: ButtonStyledWidth.FULL,
            }}
            name={getValueForKey(
              translations,
              "nav_bar.nav_card_continue_button",
            )}
            bgColor={credentials?.webshopDesigns?.at(0)?.colorButtonContinue}
            testid={TEST_ID.MIXTURE_TAB.CONTINUE_BUTTON}
            onClick={() => onConfigMix()}
          />
        </Flex>
      ) : null}
    </MixtureTabStyled>
  );
};

export default MixtureTab;
